import React from "react";
import { useNavigate } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";

// Shared storefront top navigation bar (Accueil / À propos / Blogue / Catalogue / Contact)
export const StoreNav = ({ active }) => {
  const { t } = useLang();
  const navigate = useNavigate();
  const item = "px-5 py-3 text-[13px] font-bold uppercase tracking-wide transition-colors duration-150";
  const cls = (key) => `${item} ${active === key ? "bg-[#465f73]" : "hover:bg-[#465f73]"}`;
  return (
    <div className="flex flex-wrap items-stretch bg-[#2e3a47] text-white" data-testid="store-nav">
      <button onClick={() => navigate("/")} className={cls("home")} data-testid="nav-home">{t.home}</button>
      <button onClick={() => navigate("/apropos-fr")} className={cls("about")} data-testid="nav-about">{t.aboutCompany}</button>
      <button onClick={() => navigate("/dernieres-nouvelles")} className={cls("blog")} data-testid="nav-blog">{t.blog}</button>
      <button onClick={() => navigate("/catalogue")} className={cls("catalog")} data-testid="nav-catalog">{t.catalog}</button>
      <button onClick={() => navigate("/contactez-nous")} className={cls("contact")} data-testid="nav-contact">{t.contact}</button>
    </div>
  );
};
